import { runWorkflow } from "../../../lib/Models/Workflows/SelectableDimensionWorkflow";
import ViewState from "../../../lib/ReactViewModels/ViewState";
import Terria from "../../../lib/Models/Terria";
import Icon from "../../../lib/Styled/Icon";
import SimpleCatalogItem from "../../Helpers/SimpleCatalogItem";
describe("SelectableDimensionWorkflow", function () {
  let viewState;
  let terria;
  beforeEach(function () {
    terria = new Terria();
    viewState = new ViewState({
      terria,
      catalogSearchProvider: undefined
    });
  });
  it("can run a workflow", function () {
    var _terria$selectableDim;
    const item = new SimpleCatalogItem("simple", terria);
    const setSizeWorkflow = {
      name: "Workflow name",
      icon: Icon.GLYPHS.cube,
      item,
      selectableDimensions: [{
        type: "group",
        name: "Cube size",
        selectableDimensions: [{
          type: "numeric",
          name: "Size (meters)",
          setDimensionValue: () => {}
        }]
      }]
    };
    expect(terria.selectableDimensionWorkflow).toBeUndefined();
    runWorkflow(viewState, setSizeWorkflow);
    expect((_terria$selectableDim = terria.selectableDimensionWorkflow) === null || _terria$selectableDim === void 0 ? void 0 : _terria$selectableDim.name).toBe(setSizeWorkflow.name);
  });
});